import React, { useState } from 'react'

import { Skeleton, usePAWStore } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { useTranslation } from '~/app/i18n/client'
import { LeaderboardItems } from '../components/leaderboard-items'
import { PAWSectionType } from './paw-section-types'

export const Leaderboard: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()
  const { date } = usePAWStore((state) => state)
  const { t: translate } = useTranslation()
  const [page, setPage] = useState(0)

  const isTeamSpecific = content?.metadata?.isTeamSpecific ?? false

  const {
    data: individualLeaderboard,
    isLoading: individualLeaderboardLoading,
  } = api.pawDashboards.getIndividualLeaderboard.useQuery(
    {
      year: date?.year,
      rankByCurrency: ['POINTS'],
      page,
      ...(content?.metadata?.params ?? {}),
    },
    {
      enabled: !isTeamSpecific,
    },
  )

  const { data: teamLeaderboard, isLoading: teamLeaderboardLoading } =
    api.pawDashboards.getTeamRankings.useQuery(
      {
        year: date?.year,
        rankByCurrency: ['POINTS'],
        page,
        ...(content?.metadata?.params ?? {}),
      },
      {
        enabled: isTeamSpecific,
      },
    )

  const leaderboard = isTeamSpecific ? teamLeaderboard : individualLeaderboard

  const isLoading = isTeamSpecific
    ? teamLeaderboardLoading
    : individualLeaderboardLoading

  const getPrevOrNext = (action: 'prev' | 'next') => {
    action === 'next'
      ? setPage((prev) => prev + 1)
      : setPage((prev) => prev - 1)
  }

  return (
    <section id={content?.sectionId} data-testid={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Regions Leaderboard'}
      </h2>
      {isLoading ? (
        <Skeleton className="h-[350px] w-full" />
      ) : leaderboard?.items?.length ? (
        <LeaderboardItems
          items={leaderboard?.items}
          rawLeaderboard={leaderboard}
          getPrevOrNext={getPrevOrNext}
          isTeamSpecific={isTeamSpecific}
        />
      ) : (
        <div className="text-sm text-slate-800">
          {translate('pawDashboards.noDataFound')}
        </div>
      )}
    </section>
  )
}
